import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const INITIAL_BUTTONS = [
    { label: "ГЛАВНАЯ", category: "main" },
    { label: "PREMIUM", category: "premium" },
    { label: "АКССЕССУАРЫ", category: "accessories" },
    { label: "ТОРГОВАЯ ПЛОЩАДКА", category: "tp" },
    { label: "КУПОНЫ", category: "coupons" },
];

const NEXT_BUTTONS = [
    { label: "КОСТЮМЫ", category: "costumes" },
    { label: "ОРУЖИЕ", category: "weapons" },
    { label: "НАБОРЫ", category: "kits" },
    { label: "ЛАРЦЫ", category: "boxes" },
    { label: "КАБАРЕ", category: "cabarets" },
    { label: "ПРОЧЕЕ", category: "other" },
];

const ShopCategoryButtons = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const activeCategory = searchParams.get("category") || "main";
    const [isNext, setIsNext] = useState(
        NEXT_BUTTONS.some((btn) => btn.category === activeCategory),
    );

    useEffect(() => {
        setIsNext(NEXT_BUTTONS.some((btn) => btn.category === activeCategory));
    }, [activeCategory]);

    const currentButtons = useMemo(
        () => (isNext ? NEXT_BUTTONS : INITIAL_BUTTONS),
        [isNext],
    );

    const handleShift = () => {
        setIsNext(!isNext);
    };

    const handleClick = (category) => {
        setIsNext(NEXT_BUTTONS.some((btn) => btn.category === category));
        navigate(`/ucp/shop?category=${category}`);
    };

    return (
        <div className="shop-filter-buttons-wrapper">
            {isNext && (
                <button
                    className="shop-filter-button shop-filter-button--back fade-in-out"
                    onClick={handleShift}
                >
                    НАЗАД
                </button>
            )}
            {currentButtons.map((btn) => (
                <button
                    key={btn.category}
                    className={`shop-filter-button  fade-in-out ${btn.category === activeCategory ? "active" : ""}`}
                    onClick={() => handleClick(btn.category)}
                >
                    {btn.label}
                </button>
            ))}
            {!isNext && (
                <button
                    className="shop-filter-button shop-filter-button--next shop-title-button-next fade-in-out"
                    onClick={handleShift}
                >
                    ДАЛЕЕ
                </button>
            )}
        </div>
    );
};

export default ShopCategoryButtons;
